import React from "react";

const Button = ({
  children,
  className,
  size = "medium",
  variant = "primary",
  color = "standard",
  rounded = false,
  disabled,
  responsive = true,
  ...rest
}) => {
  const colorClass = {
    standard: {
      primary: `text-white bg-wce-navy-light border border-wce-navy-light
        hover:bg-wce-navy-dark hover:border-wce-navy-dark shadow-wce-softer`,
      secondary: `text-wce-navy-light bg-white border border-wce-navy-light
        hover:bg-wce-neutral-3 shadow-wce-softer`,
      link: `text-wce-navy-light bg-transparent border border-transparent
        hover:text-wce-navy-dark`,
    },
    danger: {
      primary: `text-white bg-wce-pink-bright border border-wce-pink-bright
        hover:bg-wce-pink-darkest hover:border-wce-pink-darkest shadow-wce-softer`,
      secondary: `text-wce-pink-bright bg-white border border-wce-pink-bright
        hover:bg-wce-neutral-3 shadow-wce-softer`,
      link: `text-wce-pink-bright bg-transparent border border-transparent
        hover:text-wce-pink-darkest`,
    },
  };

  const sizeClass =
    variant === "link"
      ? {
          xs: "text-xs",
          small: "text-sm",
          medium: "text-sm",
        }
      : {
          small: "px-2 text-sm",
          medium: !responsive
            ? "px-4 py-1 text-sm"
            : "px-2 sm:px-4 py-1 text-sm",
          large: !responsive
            ? "px-4 py-2"
            : "px-2 sm:px-4 py-1 sm:py-2 text-sm sm:text-base",
        };

  const roundedClass = rounded ? "rounded-[100px]" : "rounded-sm";

  const variantClass = disabled
    ? "text-wce-neutral-6 bg-wce-neutral-3 border border-wce-neutral-5"
    : colorClass?.[color]?.[variant];

  return variant !== "link" ? (
    <button
      className={`${sizeClass?.[size]} ${variantClass}
      ${roundedClass} ${className} duration-200`}
      disabled={disabled}
      {...rest}
    >
      {children}
    </button>
  ) : (
    <span
      className={`${sizeClass?.[size]} ${variantClass}
      ${roundedClass} ${className} duration-200 cursor-pointer`}
      disabled={disabled}
      {...rest}
    >
      {children}
    </span>
  );
};

export default Button;
